import { render, staticRenderFns } from "./suggestRead.vue?vue&type=template&id=4cd54883&scoped=true"
import script from "./suggestRead.vue?vue&type=script&lang=js"
export * from "./suggestRead.vue?vue&type=script&lang=js"
import style0 from "./suggestRead.vue?vue&type=style&index=0&id=4cd54883&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd54883",
  null
  
)

export default component.exports